import { render, staticRenderFns } from "./CreateClientDialog.vue?vue&type=template&id=10a97378&scoped=true&"
import script from "./CreateClientDialog.vue?vue&type=script&lang=js&"
export * from "./CreateClientDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateClientDialog.vue?vue&type=style&index=0&id=10a97378&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a97378",
  null
  
)

export default component.exports